import { useQuery } from "@tanstack/react-query";
import { OrdersService } from "@/services/orders/orders-service";
import { GetCommentsResult } from "@/components/OrderMessagesFlyout/order-messages-flyout.types";

const ordersService = new OrdersService();

export const useOrderMessages = (orderTaxId: string) => {
  return useQuery<GetCommentsResult, Error>({
    queryKey: ["order-messages", orderTaxId],
    queryFn: async () => {
      return ordersService.getComments(orderTaxId);
    },
    enabled: !!orderTaxId,
    staleTime: 30_000,
  });
};
